import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { MenuItem, SelectItem, TreeNode, MessageService } from 'primeng/api';
import { Tooltip } from 'primeng/tooltip';
import { CampaignController } from '@Workspace/_generated/services';
import { eEntityStatus, eCampaignStatus, eStandardCampaginChannel, eChannel, eChannelType, eFileType, eUserRole, eVideoType, eCallToAction, eStoriesType, eAccountType } from '@Workspace/_generated/enums';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { FileUpload } from '../../../../../shared-core/components/file-upload/file-upload.component';
import { CartItemService } from '../../../../../shared-core/components/card-item/card-item.service';
import { ICreativeAssetDto, ICreativeDto, IUploadPayloadModelDto, IUpload, IFacebookDetailsJson, IFacebookNewsFeedDetailJson, IInStreamVideoJson, IDetailJson, IDescriptionJson } from '@Workspace/_generated/interfaces';
import { IBaseCampaignDto } from '@Workspace/_generated/interfaces';
import { FileUploadService } from '../../../../services/file-upload.service';
import { Functions, LookUps, Constants } from '@Workspace/common';
import { AuthService } from '@Workspace/auth';

@Component({
    selector: 'facebook-carousel',
    templateUrl: './facebook-carousel.component.html',
    styleUrls: ['./facebook-carousel.component.scss']
})
export class FacebookCarouselComponent implements OnInit, OnDestroy {
    constructor(
        public campaignController: CampaignController,
        public messageService: MessageService,
        public router: Router,
        private cardItemService: CartItemService,
        private activatedRoute: ActivatedRoute,
        private fileUploadService: FileUploadService,
        private authService: AuthService,
    ) { }

    @Input() creative: ICreativeDto;
    @Input() reviewPage: boolean = false;
    @Input() isApprove: boolean = false;
    @Input() isApprovedReported: boolean;
    @Input() campaign: IBaseCampaignDto;
    @Input() landingPage: string;
    @Output() openPreviewEvent: EventEmitter<any> = new EventEmitter();
    isPreviewOpen: boolean;
    currentIndex: number;
    creativeAssetsForPreview: ICreativeAssetDto[] = [];
    ngUnsubscribe = new Subject();
    booleanTrue: boolean = true;
    booleanFalse: boolean = false;
    isUploadOk: boolean = true;
    callToActionDD: SelectItem[] = [];
    callToActionLabel: string;
    constants = Constants;
    isLandingUrlOk: boolean = true;
    titleWrongUrl: string = 'Please enter a valid Url.';
    functions = Functions;
    maxNumberOfFlights: number = 1;
    currentUser = this.authService.userSettings;
    enumAccountType = eAccountType;
    maxNumberOfCards: number = 10;

    ngOnInit() {
        this.creative.creativeAssets.sort((a, b) => {
            const [secA, fracA] = Functions.sortCreativeAssetsByDateTime(String(a.createdOn));
            const [secB, fracB] = Functions.sortCreativeAssetsByDateTime(String(b.createdOn));
            if (secA !== secB) return secA - secB;
            return fracA - fracB;
        });
        this.creative.creativeAssets.forEach(x => {
            if (!!x.file && !!x.file.urlWithToken)
                this.creativeAssetsForPreview.push(x);
        });

        this.maxNumberOfFlights = Math.max(...this.campaign.creatives.map(x => x.creativeGroup));
        //this.campaign.creatives.sort((x, y) => { return y.creativeGroup - x.creativeGroup })[0].creativeGroup;

        this.cardItemService.data
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
                //this.creative = data.creatives.find(x => x.id === this.creative.id && x.creativeTypeId === this.creative.creativeTypeId && x.creativeGroup == this.creative.creativeGroup);
                this.isUploadOk = true;
                if (!!!data.creatives) return;
                this.creative.creativeAssets.forEach(ca => {
                    if (ca.isUploadValid != null || ca.isUploadValid != undefined)
                        this.isUploadOk = this.isUploadOk && ca.isUploadValid;
                });
            });

        this.creative.creativeAssets.forEach(x => {
            if (x.detailJson == null) {
                x.detailJson = {} as IDetailJson;
                x.detailJson.headline = '';
                x.detailJson.bodyText = [];
                x.detailJson.bodyText.push('');
                x.detailJson.linkDescription = '';
                x.detailJson.landingPageUrl = '';
                x.detailJson.facebookPageUrl = '';
                x.detailJson.videoType = eVideoType.Not_set;
                // x.detailJson.destinationUrl = '';
                x.detailJson.campaignTitle = '';
                x.detailJson.advertiser = '';
                x.detailJson.companyName = '';
                x.detailJson.shortTitle = '';
                x.detailJson.longTitle = '';
                x.detailJson.shortDescription = '';
                x.detailJson.longDescription = '';
                x.detailJson.callToAction = '';
                x.detailJson.headline2 = '';
                x.detailJson.description = '';
                x.detailJson.path1 = '';
                x.detailJson.path2 = '';
                x.detailJson.displayUrl = '';
                x.detailJson.adGroup = '';
                //x.inStreamVideoJson.videoType = eVideoType.Not_set;
                x.detailJson.postText = null;
                x.detailJson.privacyPolicy = null;
                x.detailJson.customDisclaimer = null;
                x.detailJson.copyOption1 = null;
                x.detailJson.copyOption2 = null;
                x.detailJson.buttonText = null;
                x.detailJson.destinationUrl = null;
                x.detailJson.storiesType = null;
                x.detailJson.introductoryText = '';
                x.detailJson.youTubeUrlToVideo = '';
                x.detailJson.clientYoutubeChannelUrl = '';
                x.detailJson.clientYoutubeEmail = '';
                x.detailJson.displayHandle = '';
            }
        });
        if (!!this.creative.creativeAssets && !!this.creative.creativeAssets[0])
            this.callToActionLabel = Functions.getEnumName(eCallToAction, this.creative.creativeAssets[0].callToAction);
        this.callToActionDD = LookUps.getCTAFacebookEnum();
        this.callToActionDD.unshift({ label: "-", value: 0 });

    }

    setCreativeCallToAction(event) {
        this.callToActionLabel = Functions.getEnumName(eCallToAction, event.value);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    openPreview(event) {
        this.openPreviewEvent.emit(event);
        // this.currentIndex = this.creativeAssetsForPreview.findIndex(x => x.id == event.id);
        // this.isPreviewOpen = true;
    }

    showHideDialog(event: any) {
        this.isPreviewOpen = event.visible;
    }

    addCard() {
        if (this.creative.creativeAssets.length < (this.maxNumberOfCards* 2)) {
            for(let i = 0; i < (this.doAssetsHaveDescription() ? 2 : 1); i++){
                let newAsset = {} as ICreativeAssetDto;
                newAsset.id = crypto.randomUUID();
                newAsset.width = 0;
                newAsset.height = 0;
                newAsset.isValid = null;
                newAsset.creativeId = this.creative.id;
                newAsset.fileType = null;
                newAsset.fileSize = 0;
                newAsset.imageUrl = null;
                newAsset.fileName = null;
                newAsset.url = null;
                newAsset.isChanged = null;
                newAsset.isUploadValid = null;
                newAsset.isDeleted = null;

                if(this.doAssetsHaveDescription() && newAsset.descriptionJson == null){
                    newAsset.descriptionJson = {} as IDescriptionJson;
                    newAsset.descriptionJson.position = i;
                    newAsset.descriptionJson.cardNumber = Math.floor(this.creative.creativeAssets.length / 2);
                }
    
                if (newAsset.detailJson == null) {
                    newAsset.detailJson = {} as IDetailJson;
    
                    newAsset.detailJson.headline = '';
                    newAsset.detailJson.bodyText = [];
                    newAsset.detailJson.bodyText.push('');
                    newAsset.detailJson.linkDescription = '';
                    newAsset.detailJson.landingPageUrl = '';
                    newAsset.detailJson.facebookPageUrl = '';
                    newAsset.detailJson.videoType = 0;
                    // newAsset.detailJson.destinationUrl = '';
                    newAsset.detailJson.campaignTitle = '';
                    newAsset.detailJson.advertiser = '';
                    newAsset.detailJson.companyName = '';
                    newAsset.detailJson.shortTitle = '';
                    newAsset.detailJson.longTitle = '';
                    newAsset.detailJson.shortDescription = '';
                    newAsset.detailJson.longDescription = '';
                    newAsset.detailJson.callToAction = '';
                    newAsset.detailJson.headline2 = '';
                    newAsset.detailJson.description = '';
                    newAsset.detailJson.path1 = '';
                    newAsset.detailJson.path2 = '';
                    newAsset.detailJson.displayUrl = '';
                    newAsset.detailJson.adGroup = '';
                    newAsset.detailJson.postText = null;
                    newAsset.detailJson.privacyPolicy = null;
                    newAsset.detailJson.customDisclaimer = null;
                    newAsset.detailJson.copyOption1 = null;
                    newAsset.detailJson.copyOption2 = null;
                    newAsset.detailJson.buttonText = null;
                    newAsset.detailJson.destinationUrl = null;
                    newAsset.detailJson.storiesType = null;
                    newAsset.detailJson.introductoryText = '';
                }
                this.creative.creativeAssets.push(newAsset);
                newAsset.detailJson.youTubeUrlToVideo = '';
                newAsset.detailJson.clientYoutubeChannelUrl = '';
                newAsset.detailJson.clientYoutubeEmail = '';
                newAsset.detailJson.displayHandle = '';
            }
        }
    }

    validationLandingPageMessage(i: number) {
        let textToMacth = this.creative.creativeAssets[i].detailJson.landingPageUrl;
        // var regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?%#[\]@!\$&'\(\)\*\+,;=.]+$/;
        var regex = /^[a-zA-Z0-9]+[^.\n]*[.][^.\n]+([.][^.\n]+)*$/;
        var found = textToMacth.match(regex);
        this.isLandingUrlOk = true;
        if (found == null) {
            this.isLandingUrlOk = false;
        }
    }

    getGroupedCreativeAssets(){
        if(!this.doAssetsHaveDescription())
            return this.creative.creativeAssets;
        else
            return this.creative.creativeAssets.filter(x => x.descriptionJson?.position == 0);
    }
    
    getCardCreativeAssets(index: number){
        return this.creative.creativeAssets.filter(x => x.descriptionJson?.cardNumber == index);
    }

    doAssetsHaveDescription(){
        return !this.creative?.creativeAssets?.some(x => x.descriptionJson == null);
    }
}
